import type { sendEventOnShowIncomeConfirmationPlaque } from 'shared/lib/sendGAEvents';
import type { TOffer } from 'shared/types/TRankingService';

import { getAnalyticsBadgesParam } from './getAnalyticsBadgesParam';
import { getAnalyticsProductParams } from './getAnalyticsProductParams';
import { getAnalyticsSummariesParams } from './getAnalyticsSummariesParams';
import type { TCommonMplAnalyticsParams } from './getCommonMplAnalyticsParams';

export const getAnalyticsOnIncomeConfirmationData = (
  commonMplAnalyticsParams: TCommonMplAnalyticsParams,
  offer: TOffer,
  timeOnPageInSeconds: number,
): Parameters<typeof sendEventOnShowIncomeConfirmationPlaque>[0] => ({
  ...commonMplAnalyticsParams,
  ...getAnalyticsProductParams(offer),
  ...getAnalyticsSummariesParams(offer),
  badges: getAnalyticsBadgesParam(offer),
  timeOnPage: timeOnPageInSeconds,
});
